/* globals addQueryParam, getNextDays, updateEventBind, dateMidpoint, getTimeRange */
/* The MIT License
 *
 * Copyright (c) 2013, Sebastian Sdorra
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

'use strict';

var urlPfx = '2/factndx/{0}';
var topLegacyPfx = '/application/site_files';
var frontendPfx = '/application/f/home.html#/';
var countt = 0;
var SIX_DAYS = 6*24*60*60*1000;
// list of every widget, used for iterating over chartProperties object
var masterWidgetList = ['criticalShortages', 'criticalShortagesManufactured', 'excessAndObsoleteInventory', 'excessInventory',
	'obsoleteInventory', 'excessOverLeadTimeMultiple', 'newPurchaseReq', 'earlyDeliveries',
	'openPOsForExcessMaterial', 'openPOsForExcessOverLeadTimeMultiple', 'purchasedInventory', 'manufacturedInventory', 'clearToBuildPercentage',
	'clearToCommitPercentage', 'purchaseReqToFirm', 'ppoInsideLeadTime', 'prOnTimeFirmDate', 'vmiInventoryOverMax', 'vmiPartsUnderMin', 'ropItemsOverMax',
	'itemsUnderSafetyStock', 'itemsUnderSafetyStockManufactured', 'posToCancelNext90Days', 'openPOsForObsoleteMaterial',
	'daysOfInventory', 'customTextWidget', 'poBehindSchedule', 'posToActionNext12MonthsHistory', 'mrpResizeOpportunity',
	'poPlacement', 'productionOrderPlacement', 'ppoOnTimeFirmDates', 'poConfirmation', 'purchaseReqCreatedInsideLeadTime', 'shortagesByOrderLines',
	'aggregateRiskScores', 'componentAvailabilityPercent', 'indirectSpend'];

// name must match the chart type in the API call
// eventName: event watched by directive, of the form 'event:<widgetname>Ctrl:getChart'
// xAxisField: X axis for chart
// xAxisInterval: 'weekly', supposedly 'daily' supported too
// yAxisFieldKey: name of field used for Y axis
// yAxisFieldLabel: label for axis, looks unused
// yAxisFieldName: label used in tooltip
// fmtService: Formatting service used for the values of the chart
// addnlLabelText: Label used for the bottom number if there is one, or top if there isn't
// bottomData: boolean to say whether or not there is a number in the bottom section of the bgNums
// bgNumClass: class used for the color of the bgNum
// bgNumParentDivClass: class used to style the right section for 1 or 2 values
// bgNumValIdx: 'end'
// addnlBgNumUnits: additional units added to the end of the bgNum
// drilldownDefaultTabs: tab to show in item drilldown
// drillDownUrl: url to follow when "view report" is clicked
// expandedTitle: title to show for details table
// chartUrl: url for chart data
// tableUrl: url for table data
// title: override title of widget
// location: ??
// dataFunction: function for processing data before display
// widgetName: looks unused

var shortageChartConfig = function(scope, rootScope, innerHeight, elem, buyerStdCurrentShortagesService, state, drilldownFunctionsService) {
	var data = _.merge({
		shortageWithFirmedCount: 0,
		shortageWithPlannedCount: 0,
		shortageWithNoSupplyCount: 0
	}, (scope.data && scope.data[0]) ? scope.data[0] : {});

	var criticalityLvlDataJson = undefined;
	// Shortage Criticality rank for None/Non Critical to make it last
	// Matches shortage-criticality-level.service.js, but can't use service in config
	var RANK_FOR_NONE = 9999;
	var DISPLAY_FOR_NONE = 'Non Critical';
	var supplyLvlDataJson = [
		{ shortageWithFirmedCount: data.shortageWithFirmedCount },
		{ shortageWithPlannedCount: data.shortageWithPlannedCount },
		{ shortageWithNoSupplyCount: data.shortageWithNoSupplyCount }
	];
	var dataKeys = ['shortageWithFirmedCount', 'shortageWithPlannedCount', 'shortageWithNoSupplyCount'];
	var criticalityLvlCategories;
	var criticalityLvlIdToLabel = {};
	var criticalityLvlColors = {};
	var itemType = scope.itemType;
	if ((scope.settings && scope.settings.breakdown) && scope.settings.breakdown === 'criticalityLevel') {
		var primaryColors = {
			'p0': '#c30015',
			'p1': '#f42f2f',
			'p2': '#ff9b30',
			'p3': '#f4ce00',
			'p4': '#7cc4fa'
		};
		var criticalityLvlRanks = scope.criticalityLvlRanks;
		setCriticalityLevelColorsBasedOnRank();

		var criticalityLevelData = (scope.data && scope.data[0]) ? scope.data[0].criticalityLevelCounts : undefined;
		var dataJsonArray = [];
		if (criticalityLevelData) {
			criticalityLevelData = JSON.parse(criticalityLevelData);
			if (_.isObject(criticalityLevelData)) {
				_.each(criticalityLevelData, function (value, key) {
					var dataKey = key === 'None' ? DISPLAY_FOR_NONE: key;
					dataJsonArray.push({
						'key': dataKey,
						'value': value,
						'rank': criticalityLvlRanks && criticalityLvlRanks[dataKey] ? criticalityLvlRanks[dataKey].rank : RANK_FOR_NONE,
						'id': criticalityLvlRanks && criticalityLvlRanks[dataKey] ? criticalityLvlRanks[dataKey].id : -1
					});
				});
			}
		}
		var criticalityLvlKeys = [];
		criticalityLvlDataJson = _.orderBy(dataJsonArray, ['rank']).map(function(group, index) {
			var obj = {};
			obj[group.key] = group.value;
			criticalityLvlKeys.push(group.key);
			criticalityLvlIdToLabel[group.key] = group.id;
			return obj;
		});
		dataKeys = criticalityLvlKeys;
		criticalityLvlCategories = getCriticalityLabels(criticalityLvlKeys);
	}

	function getCriticalityLabels(criticalityLvlKeys) {
		var tempSvg = d3.select('body').append('svg');
		var tempTextElement = tempSvg.append('text');
		var categories = [];
		var limitLabelWidth = rootScope.slideshowView ? 180 : 120;
		angular.forEach(criticalityLvlKeys, function (category) {
			var tempCategory = category;
			var trimAmount = 0;
			var textSize = tempTextElement.node().getBBox();
			// font isn't monospace, so have to draw and measure the text to trim to a given width
			while (textSize.width > limitLabelWidth) {
				trimAmount += 1;
				tempCategory = category.substring(0, category.length - trimAmount) + '...';
				tempTextElement.text(tempCategory);
				textSize = tempTextElement.node().getBBox();
			}
			categories.push(tempCategory);
		});
		tempSvg.remove();
		return categories;
	}

	function setCriticalityLevelColorsBasedOnRank() {
		var criticalityLevelsOrderByRank = _.toArray(scope.criticalityLvlRanks);
		criticalityLevelsOrderByRank = _.orderBy(criticalityLevelsOrderByRank, ['rank']).map(function (group, index) {
			criticalityLvlColors[group.label] = primaryColors['p' + index] ? primaryColors['p' + index] :  '#7cc4fa';
		});
		criticalityLvlColors[DISPLAY_FOR_NONE] = '#b6e4ff';
	}

	var config = {
		size: getSize(),
		bindto: elem[0],
		data: {
			json: criticalityLvlDataJson ? criticalityLvlDataJson : supplyLvlDataJson,
			keys: { value: dataKeys },
			groups: [dataKeys],
			labels: false,
			type: 'bar'
		},
		tooltip: { show: true },
		axis: {
			rotated: true,
			x: {
				categories: criticalityLvlDataJson ? criticalityLvlCategories: ['Has Firm Supply', 'Has Planned Supply', 'No Supply'],
				tick: { multiline: false},
				type: 'category'
			},
			y: {
				tick: {
					values: [0,
						criticalityLvlDataJson ? (scope.data && scope.data[0]) ? scope.data[0].shortageCount : undefined :
							Math.max(data.shortageWithFirmedCount, data.shortageWithPlannedCount, data.shortageWithNoSupplyCount)]
				}
			}
		},
		padding:  getPadding(),
		legend: { hide: true }
	};

	if (!criticalityLvlDataJson) {
		config.data.names = {
			'shortageWithFirmedCount': 'Items in shortage',
			'shortageWithPlannedCount': 'Items in shortage',
			'shortageWithNoSupplyCount': 'Items in shortage'
		};
		config.data.colors = {
			shortageWithFirmedCount: '#005fa5',
			shortageWithPlannedCount: '#f4ce00',
			shortageWithNoSupplyCount: '#d30a0a'
		};
		config.data.classes = {
			shortageWithFirmedCount: 'with-firmed',
			shortageWithPlannedCount: 'with-planned',
			shortageWithNoSupplyCount: 'no-supply'
		};
	} else {
		config.data.colors = criticalityLvlColors;
	}

	function getPadding() {
		return {
			left: rootScope.slideshowView ? 200 : 140,
			bottom: 10,
			top: 10,
			right: 10
		};
	}

	function getSize() {
		return {
			height: rootScope.slideshowView ? innerHeight - 300 :
				innerHeight > 800 ? 220 : 150
		};
	}

	jQuery(elem).off('click', '.tick').on('click', '.tick', function(e) {
		var target = $(e.target).closest('.tick');
		var i = jQuery(elem).find('.c3-axis .tick').index(target);
		var type;
		if (!criticalityLvlDataJson) {
			type = ['firmed', 'planned', 'nosupply'][i];
		} else {
			type = criticalityLvlIdToLabel[dataKeys[i]];
		}
		var url = state.href('app.supply-chain.material-shortages/shortages-by-item');
		var filters = buyerStdCurrentShortagesService.getDrilldownFilters(type, (scope.settings && scope.settings.breakdown) ? scope.settings.breakdown : undefined, null, true);
		filters['itemType'] = itemType;
		url = drilldownFunctionsService.getReportDrilldownUrl(url.substring(2), null, filters, true);
		window.open(url, '_blank');
	});

	return config;
};

var chartProperties = {
	'criticalShortages': {
		name: 'Current Shortages (Purchased)',
		description: 'The total number of purchased items that have more past due requirements than on hand quantity.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Shortages'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:criticalShortagesCtrl:getChart',
		yAxisFieldLabel: 'Shortages By Week',
		yAxisFieldName: 'Parts With Shortage',
		fmtService: 'integerFormatService',
		addnlBgNumUnits: 'Items',
		expandedTitle: 'Critical shortages, sorted by lead time',
		tableUrl: urlPfx + '/CriticalShortagesDetail?itemType=Purchased',
		drillDownUrl: '/application/f/home.html#/supply-chain/material-shortages/shortages-by-item/?drilldown=1&sort=firstCriticalBucket&daysInShortageValueOne=1&daysInShortageComparator=gte',
		widgetName: 'Projected Critical Shortages',
		location: 'shortages widget',
		isEditable: true,
		templateUrl: '/application/f/dashboard/widgets/currentShortagesWidget.html',
		chartUrl: urlPfx + '/BuyerStandardWork/MyCurrentShortages?itemType=Purchased',
		reactDrilldownUrl: frontendPfx + 'supply-chain/material-shortages/shortages-by-item',
		reactDrilldownSorters: [{ property: 'firstCriticalBucket', direction: 'ASC' }],
		reactDrilldownFilters: [
			{ id: 'daysInShortage', comparator: 'Greater Than or Equal To', valueOne: 1 },
			{ id: 'itemType', values: ['Purchased'] }
		],
		isNewDrillDown: true,
		graphConfig: shortageChartConfig
	},
	'criticalShortagesManufactured': {
		name: 'Current Shortages (Manufactured)',
		description: 'The total number of manufactured items that have more past due requirements than on hand quantity.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Shortages'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:criticalShortagesManufacturedCtrl:getChart',
		yAxisFieldLabel: 'Shortages By Week',
		yAxisFieldName: 'Parts With Shortage',
		fmtService: 'integerFormatService',
		addnlBgNumUnits: 'Items',
		expandedTitle: 'Critical shortages for Manufactured items, sorted by lead time',
		tableUrl: urlPfx + '/CriticalShortagesDetail?itemType=Manufactured',
		drillDownUrl: '/application/f/home.html#/supply-chain/material-shortages/shortages-by-item/?drilldown=1&sort=firstCriticalBucket&daysInShortageValueOne=1&daysInShortageComparator=gte&itemType=Manufactured',
		widgetName: 'Current Shortages (Manufactured)',
		location: 'shortages widget manufactured',
		isEditable: true,
		templateUrl: '/application/f/dashboard/widgets/currentShortagesWidget.html',
		chartUrl: urlPfx + '/BuyerStandardWork/MyCurrentShortages?itemType=Manufactured',
		reactDrilldownUrl: frontendPfx + 'supply-chain/material-shortages/shortages-by-item',
		reactDrilldownSorters: [{ property: 'firstCriticalBucket', direction: 'ASC' }],
		reactDrilldownFilters: [
			{ id: 'daysInShortage', comparator: 'Greater Than or Equal To', valueOne: 1 },
			{ id: 'itemType', values: ['Manufactured'] }
		],
		isNewDrillDown: true,
		graphConfig: shortageChartConfig
	},
	'aggregateRiskScores': {
		name: 'Aggregate Risk Score',
		description: 'The total number of items with a risk score 1 or greater. The stacked bars will show how many items fall into high, medium and low risk.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/pr_inside_lead_time.png',
		categories: ['All', 'Shortages'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:aggregateRiskScoresCtrl:getChart',
		yAxisFieldLabel: 'Aggregate Risk Score by Week',
		fmtService: 'integerFormatService',
		addnlBgNumUnits: 'Items',
		expandedTitle: 'Placeholder',
		drillDownUrl: '/application/f/home.html#/supply-chain/line-of-balance/all-parts/?drilldown=1&sort=aggregateRiskScore&sortDesc=1&aggregateRiskScoreValueOne=0&aggregateRiskScoreComparator=gt&itemType=Manufactured,Purchased',
		widgetName: 'Aggregate risk score',
		location: 'aggregate risk score widget',
		isEditable: false,
		templateUrl: '/application/f/dashboard/widgets/aggregateRiskScoresWidget.html',
		reactDrilldownUrl: frontendPfx + 'supply-chain/line-of-balance/all-parts',
		reactDrilldownSorters: [{ property: 'aggregateRiskScore', direction: 'DESC' }],
		reactDrilldownFilters: [
			{ id: 'aggregateRiskScore', comparator: 'Greater Than', valueOne: 0 },
			{ id: 'itemType', values: ['Purchased', 'Manufactured'] }
		],
		isNewDrillDown: true,
		graphConfig: function(config, scope, translate, formatService, $timeout, weeklyDiffService) {

			var scopeAccessor = scope.$parent.$parent;

			function updateYAxisRange() {
				var currentRange = scope.chart.axis.range();
				var newRange = getMinMaxRange();
				currentRange.min.y = newRange.min;
				currentRange.max.y = newRange.max;
				scope.chart.axis.range(currentRange);
			}

			function getMinMaxRange() {
				var dataSeriesNames = ['Low', 'Medium', 'High'];
				if (scope.chart) {
					dataSeriesNames = [];
					var visibleData = scope.chart.data.shown();
					for (var i = 0; i < visibleData.length; i++) {
						dataSeriesNames.push(visibleData[i].id);
					}
				}
				var max = Math.max.apply(null, config.data.json.map(function(row) { 
					var val = 0;
					for (var i = 0; i < dataSeriesNames.length; i++) {
						val += row[dataSeriesNames[i]];
					}
					return val; 
				}));

				return {
					min: 0,
					max: max
				};
			}


			config.data.json = config.data.json.map(function(row) {
				// default values to zero - because 'fake' weeks don't have all the values
				row = _.extend(
					{
						Low: 0,
						Medium: 0,
						High: 0
					},
					row
				);
				if(!row.isFake && row.aggregateRiskScoreCounts){
					var aggregateRiskScoreCountsJSON = JSON.parse(row.aggregateRiskScoreCounts);

					for (var key in aggregateRiskScoreCountsJSON) {
						row[key] = aggregateRiskScoreCountsJSON[key];
					}
				}

				// Aggregate
				row.total = row.Low + row.Medium + row.High;
				return row;
			});
			var weeks = config.data.json;
			if (weeks.length >= 1) {
				if (scope.$parent.formattedBgNum) {
					scope.$parent.formattedBgNum.value = formatService.getWithParameters(weeks[weeks.length - 1].total, 0);
				}
			}
			if (weeks.length >= 2) {
				var diff = weeklyDiffService.getDataPoints(weeks);
				var delta = diff.lastDataPoint.total - diff.previousDataPoint.total;
				if (isNaN(delta)) {
					scope.$parent.diff = null;
				} else {
					scope.$parent.diff = {
						delta: delta,
						status: delta > 0 ? 'bad' : 'good'
					};
					scope.$parent.formattedDiff = {
						delta: d3.format(',')(Math.abs(delta)),
						addnlLabelText: weeklyDiffService.getAdditionalLabelText(diff.previousDataPoint)
					};
				}
			}
			config.data.type = 'bar';
			config.data.x = 'date';
			var range = getMinMaxRange();
			config.axis.y.min = 0;
			config.axis.y.max = range.max;

			config.axis.x.type = 'category';
			var format = config.axis.x.tick.format;
			config.axis.x.tick = {
				format: function(x) {
					return format(config.data.json[Math.round(x)]['date']);
				},
				outer: false,
				count: 5,
				multiline: false
			};
			config.data.names = {
				Low: translate.instant('Low'),
				Medium: translate.instant('Medium'),
				High: translate.instant('High')
			};
			config.data.order = function(t1, t2) {
				// sort in same order as the config.data.groups[0] array
				// first item in array at bottom of stack
				// this is the opposite of the order they appear in code, where
				// first item is on the top of a list.
				var a = config.data.groups[0].indexOf(t1.id),
					b = config.data.groups[0].indexOf(t2.id);
				return a > b ? 1 : a < b ? -1 : 0;
			};
			config.data.groups = [
				[
					'High',
					'Medium',
					'Low'
				]
			];
			config.tooltip = {
				contents: function(data, defaultTitleFormat, defaultValueFormat, color) {
					// don't show groups with 0 risk scores in tooltip
					var popupData = data.filter(function(i) { return i.value !== 0; } );
					if (!popupData || popupData.length == 0) {
						return '';
					}
					return this.getTooltipContent(popupData, defaultTitleFormat, defaultValueFormat, color);
				}
			};
			config.size.height = Math.max(250, config.size.height);
			config.data.color = undefined;
			config.data.colors = {
				Low: '#F4CE00',
				Medium: '#ff9b30',
				High: '#c30015'
			};

			config.data.keys.value = config.data.groups[0].filter(function(group) {
				return Math.max.apply(null, _.map(config.data.json, group)) > 0;
			});
			config.legend = {
				show: config.data.keys.value.length > 1,
				position: 'bottom',
				item: {
					onclick: function (id) {
						scope.chart.toggle(id);
						var selectedKeys = [];
						// update bgnum and delta
						var visibleValue = 0.0;
						var i;

						var lastPoint = config.data.json[config.data.json.length - 1];
						var visibleData = scope.chart.data.shown();
						for (i = 0; i < visibleData.length; i++) {
							 visibleValue += lastPoint[visibleData[i].id];
							 selectedKeys.push(visibleData[i].id);
						}
						$timeout(function () {
						 	scope.$parent.$parent.formattedBgNum.value = formatService.getWithParameters(
						 		visibleValue, 0, scope.currency);
						});

						scope.deltaValue = 0;

						if (config.data.json.length > 1) {
							var weeksBack = config.data.json.length >= 3 ? 3 : 2;
							var previousPoint = config.data.json[config.data.json.length - weeksBack];

							var previousValue = 0.0;
							for (i = 0; i < visibleData.length; i++) {
								previousValue += previousPoint[visibleData[i].id];
							}
							scope.deltaValue = visibleValue - previousValue;
							$timeout(function () {
								scope.$parent.formattedDiff.delta = formatService.getWithParameters(
									scope.deltaValue, 0, scope.currency);
							});
						}

						var url = decodeURIComponent(scope.$parent.content.drillDownUrl);
						var params = parseQueryString(url);
						var baseUrl = url.split('?')[0];
						// clear out existing date creation query params
						delete params.orderCreationDateValueOne;
						delete params.orderCreationDateValueTwo;
						delete params.orderCreationDateComparator;
						updateYAxisRange();
					}
				}
			};
			config.data.onclick = function(d, i) {
				var filters = [
					{ id: 'aggregateRiskScoreLabel', values: [d.id] }
				];

				var url = scope.$parent.$parent.reactReportDrilldownUrl(filters, [{ property: 'aggregateRiskScore', direction: 'DESC' }], true);
				window.open(url, '_blank');
			};
			return config;
		}
	},
	'excessOverLeadTimeMultiple': {
		name: 'Excess Over Lead Time Multiple',
		description: 'The total on hand value of excess inventory based on the items\' lead time multiple (which compares the lead time to the days coverage).',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:excessOverLeadTimeMultipleCtrl:getChart',
		yAxisFieldLabel: 'Excess Over Lead Time Multiple',
		yAxisFieldName: 'Excess Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'stockSection',
		expandedTitle: 'Largest excess, sorted by amount',
		tableUrl: urlPfx + '/ExcessOverLeadTimeByItem',
		drillDownUrl: frontendPfx + 'supply-chain/excess-inventory-over-lead-time-multiple/?drilldown=1&sort=analysisExcessOnHandOverLTValue&sortDesc=1',
		widgetName: 'Excess Over Leadtime Multiple',
		location: 'excess over leadtime widget'
	},
	'excessAndObsoleteInventory': {
		name: 'Excess & Obsolete Inventory',
		description: 'The total on hand value of items considered Excess and/or Obsolete Inventory.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:excessAndObsoleteInventoryCtrl:getChart',
		yAxisFieldLabel: 'Excess And Obsolete Inventory',
		yAxisFieldName: 'Excess Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'stockSection',
		expandedTitle: 'Inventory with largest weekly increase in excess',
		tableUrl: urlPfx + '/TotalExcessValueByItem',
		drillDownUrl: frontendPfx + 'supply-chain/inventory-opportunities/excess-and-obsolete-inventory/?drilldown=1',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/excess-and-obsolete-inventory/',
		widgetName: 'Excess & Obsolete Inventory',
		location: 'excess and obsolete widget'
	},
	'excessInventory': {
		name: 'Excess Inventory',
		description: 'The total on hand value of items considered excess based on the sites\' "Excess and Obsolete Reporting" settings.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:excessInventoryCtrl:getChart',
		yAxisFieldLabel: 'Excess Inventory',
		yAxisFieldName: 'Excess Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'stockSection',
		expandedTitle: 'Inventory with largest weekly increase in excess',
		tableUrl: urlPfx + '/TotalExcessValueByItem?excessType=excess',
		drillDownUrl: frontendPfx + 'supply-chain/inventory-opportunities/excess-and-obsolete-inventory/?drilldown=1&excessType=excess',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/excess-and-obsolete-inventory/',
		reactDrilldownFilters: [
			{ id: 'excessType', values: ['excess'] }
		],
		widgetName: 'Excess Inventory',
		location: 'excess widget'
	},
	'indirectSpend': {
		name: 'Indirect Spend',
		description: 'Matches the Indirect Purchase Orders report: Open PO Value for indirect material, and Unit Price times scheduled quantity for service and premium service categories.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All'],
		slideshowView: true,
		isActive: true,
		experiment: 'premium-freight',
		eventName: 'event:indirectSpendCtrl:getChart',
		yAxisFieldLabel: 'Indirect Spend',
		yAxisFieldName: 'Indirect Spend',
		yAxisFieldKey: 'indirectSpendTotal',
		fmtService: 'currencyFormatService',
		expandedTitle: 'Indirect spend by item code',
		tableUrl: urlPfx + '/IndirectSpendByItem',
		drillDownUrl: frontendPfx + 'supply-chain/indirect-purchase-orders/?drilldown=1',
		reactDrilldownUrl: frontendPfx + 'supply-chain/indirect-purchase-orders/',
		reactDrilldownFilters: [],
		reactDrilldownExperiment: 'react-indirect-purchase-orders',
		isNewDrillDown: true,
		widgetName: 'Indirect Spend',
		location: 'indirect spend widget',
		dataFunction: function (sourceData) {
			sourceData.forEach(function (sd) {
				// Indirect spend is not an item-type metric; FinishedGood is a
				// subset of Manufactured, so these two cover every item once.
				sd.indirectSpendTotal = (sd.indirectSpend || 0) + (sd.indirectSpendManufactured || 0);
			});
		}
	},
	'obsoleteInventory': {
		name: 'Obsolete Inventory',
		description: 'The total on hand value for items without requirements.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:obsoleteInventoryCtrl:getChart',
		yAxisFieldLabel: 'Obsolete Inventory',
		yAxisFieldName: 'Excess Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'stockSection',
		expandedTitle: 'Inventory with largest weekly increase in excess',
		tableUrl: urlPfx + '/TotalExcessValueByItem?excessType=obsolete',
		drillDownUrl: frontendPfx + 'supply-chain/inventory-opportunities/excess-and-obsolete-inventory/?drilldown=1&excessType=obsolete',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/excess-and-obsolete-inventory/',
		reactDrilldownFilters: [
			{ id: 'excessType', values: ['obsolete'] }
		],
		widgetName: 'Obsolete Inventory',
		location: 'obsolete widget'
	},
	'newPurchaseReq': {
		name: 'New Purchase Requisitions',
		description: 'Displays new PRs that have been  created in the last 7 days',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:newPurchaseReqCtrl:getChart',
		yAxisFieldLabel: 'PR Count',
		yAxisFieldName: 'PR Count',
		fmtService: 'integerFormatService',
		expandedTitle: 'Recent PRs',
		tableUrl: urlPfx + '/TopNewPrs',
		drillDownUrl: frontendPfx + 'supply-chain/purchase-requisitions/?drilldown=1&sort=prCreationDate&sortDesc=1',
		reactDrilldownUrl: frontendPfx + 'supply-chain/purchase-requisitions/',
		reactDrilldownSorters: [{ property: 'orderCreationDate', direction: 'DESC' }],
		widgetName: 'New Purchase Requisitions',
		location: 'new purchase req widget'
	},
	'earlyDeliveries': {
		name: 'Early Deliveries',
		description: 'Displays the total value of early deliveries over the last seven days.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Supplier Performance'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:earlyDeliveriesCtrl:getChart',
		yAxisFieldLabel: 'Early Delivery Last 7 Days Value',
		yAxisFieldName: 'Early Delivery Last 7 Days Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'deliveriesSection',
		expandedTitle: 'Items delivered early, sorted by value in the last 7 days',
		tableUrl: urlPfx + '/TopEarlyDeliveries',
		drillDownUrl: frontendPfx + 'supply-chain/inventory-opportunities/weekly-inventory-change/?drilldown=1&sort=earlyDeliveriesLast7DaysValue&sortDesc=1',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/weekly-inventory-change/',
		reactDrilldownSorters: [{ property: 'earlyDeliveriesLast7DaysValue', direction: 'DESC' }],
		excludeMinMaxForDrilldown: true,
		widgetName: 'Early Deliveries',
		location: 'Early Deliveries'
	},
	'openPOsForExcessMaterial': {
		name: 'POs for Excess & Obsolete Inventory',
		description: 'The total on order value for excess and/or obsolete inventory.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:openPOsForExcessMaterialCtrl:getChart',
		yAxisFieldLabel: 'Open POs For Excess Material',
		yAxisFieldName: 'PO Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'stockSection',
		expandedTitle: 'Open POs for excess material, sorted by amount',
		tableUrl: urlPfx + '/ExcessPoValueByItem',
		drillDownUrl: frontendPfx + 'supply-chain/inventory-opportunities/purchase-orders-to-cancel/?drilldown=1&sort=excessOnOrderValue&sortDesc=1',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/purchase-orders-to-cancel',
		reactDrilldownSorters: [{ property: 'excessOnOrderValue', direction: 'DESC' }],
		title: 'POs for Excess & Obsolete Inventory',
		excludeMinMaxForDrilldown: true,
		widgetName: 'POs for Excess Inventory',
		location: 'open pos for excess widget'
	},
	'clearToBuildPercentage': {
		name: 'Clear To Build %',
		description: 'Clear To Build % is defined as the number of orders that are fully on hand (solid green) / the total number of orders during a configurable time period. We will include past-due orders in that time period.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		slideshowView: true,
		isActive: true,
		eventName: 'event:clearToBuildPercentageCtrl:getChart',
		yAxisFieldName: 'Clear To Build %',
		yAxisFieldKey: 'clearToBuildPercentage',
		yAxisMinAndMax: {yMin: 0, yMax: 100},
		isBadFlipped: true,
		fmtService: 'percentageFormatService',
		expandedTitle: 'Clear To Build percentage',
		reactDrilldownUrl: frontendPfx + 'supply-chain/clear-to-build',
		isNewDrillDown: true,
		widgetName: 'Clear To Build %',
		location: 'clear to build percentage widget',
		dataFunction: function (sourceData) {
			sourceData.forEach(function (sd) {
				var numerator = sd.clearToBuildCount + sd.clearToBuildCountManufactured;
				var denominator = sd.clearToBuildWindowTotalProductionOrderCount + sd.clearToBuildWindowTotalProductionOrderCountManufactured;
				if(denominator <= 0){
					sd.clearToBuildPercentage = 0;
				} else {
					sd.clearToBuildPercentage = numerator/denominator;
				}
				sd.clearToBuildPercentage *= 100;
			});
		}
	},
	'clearToCommitPercentage': {
		name: 'Clear To Commit %',
		description: 'Clear To Commit % is defined as the number of orders that are on hand (solid green) or expected in time (outlined green) / the total number of orders during a configurable time period. We will include past-due orders in that time period.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		slideshowView: true,
		isActive: true,
		eventName: 'event:clearToCommitPercentageCtrl:getChart',
		yAxisFieldName: 'Clear To Commit %',
		yAxisFieldKey: 'clearToCommitPercentage',
		yAxisMinAndMax: {yMin: 0, yMax: 100},
		isBadFlipped: true,
		fmtService: 'percentageFormatService',
		expandedTitle: 'Clear To Commit percentage',
		reactDrilldownUrl: frontendPfx + 'supply-chain/clear-to-build',
		isNewDrillDown: true,
		widgetName: 'Clear To Commit %',
		location: 'clear to commit percentage widget',
		dataFunction: function (sourceData) {
			sourceData.forEach(function (sd) {
				var numerator = sd.clearToCommitCount + sd.clearToCommitCountManufactured;
				var denominator = sd.clearToCommitWindowTotalProductionOrderCount + sd.clearToCommitWindowTotalProductionOrderCountManufactured;
				if(denominator <= 0){
					sd.clearToCommitPercentage = 0;
				} else {
					sd.clearToCommitPercentage = numerator/denominator;
				}
				sd.clearToCommitPercentage *= 100;
			});
		}
	},
	'purchaseReqToFirm': {
		name: 'Open Purchase Requisitions Inside Lead Time',
		description: 'The number of PRs that need to be firmed, grouped by PR creation date (less than 7 days, 7 - 14 days, 14 days or more).',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/pr_inside_lead_time.png',
		categories: ['All', 'Shortages'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:purchaseReqToFirmCtrl:getChart',
		xAxisField: 'date',
		yAxisFieldLabel: 'PR Count',
		yAxisFieldName: 'PR Count',
		yAxisFieldKey: 'latePRCount',
		fmtService: 'integerFormatService',
		expandedTitle: 'PRs inside of lead time, sorted by days until PO firm',
		tableUrl: urlPfx + '/TopPrInsideLeadTimeItems',
		drillDownUrl: frontendPfx + 'supply-chain/purchase-requisitions/?drilldown=1&sort=daysUntilPOFirm&maxDaysUntilPOFirm=-1',
		reactDrilldownUrl: frontendPfx + 'supply-chain/purchase-requisitions/',
		reactDrilldownSorters: [{ property: 'daysUntilPOFirm', direction: 'ASC' }],
		reactDrilldownFilters: [{id: 'daysUntilPOFirm', comparator: 'Less Than Or Equal To', valueOne: -1}],
		bgNumUnits: 'PRs',
		bgNumKey: 'latePRCount',
		widgetName: 'Open Purchase Requisitions Inside Lead Time',
		location: 'purchase req widget',
		graphConfig: function(config, scope, translate, formatService, $timeout, weeklyDiffService) {
			config.data.json = config.data.json.map(function(row) {
				// default values to zero - because 'fake' weeks don't have all the values
				row = _.extend(
					{
						latePRCount: 0,
						latePRCountUnder7: 0,
						latePRCountUnder14: 0,
						latePRCountOver14: 0,
						latePRCountManufactured: 0,
						latePRCountUnder7Manufactured: 0,
						latePRCountUnder14Manufactured: 0,
						latePRCountOver14Manufactured: 0
					},
					row
				);
				// Aggregate manufactured
				row.latePRCount += row.latePRCountManufactured;
				row.latePRCountUnder7 += row.latePRCountUnder7Manufactured;
				row.latePRCountUnder14 += row.latePRCountUnder14Manufactured;
				row.latePRCountOver14 += row.latePRCountOver14Manufactured;
				// zero out the "Unknown Age" values when newer age based data is available
				if (row.totalPRCount === undefined) {
					row.totalPRCount = row.latePRCount;
					row.latePRCount = Math.max(0, row.latePRCount - (row.latePRCountUnder7 + row.latePRCountUnder14 + row.latePRCountOver14));
				}
				return row;
			});
			var weeks = config.data.json;
			if (weeks.length >= 1) {
				if (scope.$parent.formattedBgNum) {
					scope.$parent.formattedBgNum.value = formatService.getWithParameters(weeks[weeks.length - 1].totalPRCount, 0);
				}
			}
			if (weeks.length >= 2) {
				var diff = weeklyDiffService.getDataPoints(weeks);
				var delta = diff.lastDataPoint.totalPRCount - diff.previousDataPoint.totalPRCount;
				if (isNaN(delta)) {
					scope.$parent.diff = null;
				} else {
					scope.$parent.diff = {
						delta: delta,
						status: delta > 0 ? 'bad' : 'good'
					};
					scope.$parent.formattedDiff = {
						delta: d3.format(',')(Math.abs(delta)),
						addnlLabelText: weeklyDiffService.getAdditionalLabelText(diff.previousDataPoint)
					};
				}
			}
			config.data.type = 'bar';
			config.data.x = 'date';
			config.axis.y.min = 0;
			config.axis.y.max = Math.max.apply(null, config.data.json.map(function(row) { return row.totalPRCount; }));
			config.axis.x.type = 'category';
			var format = config.axis.x.tick.format;
			config.axis.x.tick = {
				format: function(x) {
					return format(config.data.json[Math.round(x)]['date']);
				},
				outer: false,
				count: 5,
				multiline: false
			};
			config.data.names = {
				latePRCount: translate.instant('Late PRs'),
				latePRCountUnder7: translate.instant('Created < 7 days ago'),
				latePRCountUnder14: translate.instant('Created 7-14 days ago'),
				latePRCountOver14: translate.instant('Created > 14 days ago')
			};
			config.data.order = function(t1, t2) {
				// sort in same order as the config.data.groups[0] array
				// first item in array at bottom of stack
				// this is the opposite of the order they appear in code, where
				// first item is on the top of a list.
				var a = config.data.groups[0].indexOf(t1.id),
					b = config.data.groups[0].indexOf(t2.id);
				return a > b ? 1 : a < b ? -1 : 0;
			};
			config.data.groups = [
				[
					'latePRCountOver14',
					'latePRCountUnder14',
					'latePRCountUnder7',
					'latePRCount'
				]
			];
			config.tooltip = {
				contents: function(data, defaultTitleFormat, defaultValueFormat, color) {
					// don't show groups with 0 PRs in tooltip
					var popupData = data.filter(function(i) { return i.value !== 0; } );
					if (!popupData || popupData.length == 0) {
						return '';
					}
					if (popupData.length > 1) {
						var total = popupData.reduce(function(total,i){ return total+i.value; }, 0);
						popupData.push({ name: translate.instant('Total Late PRs'), id: 'totalPRCount', value: total, x: data[0].x });
					}
					return this.getTooltipContent(popupData, defaultTitleFormat, defaultValueFormat, color);
				}
			};
			config.size.height = Math.max(250, config.size.height);
			config.data.color = undefined;
			config.data.colors = {
				latePRCountUnder7: '#0C9D4D',
				latePRCountUnder14: '#F4CE00',
				latePRCountOver14: '#D30A0A',
				latePRCount: '#005FA5',
				totalPRCount: '#ffffff'
			};

			config.data.keys.value = config.data.groups[0].filter(function(group) {
				return Math.max.apply(null, _.map(config.data.json, group)) > 0;
			});
			if (config.data.keys.value.length > 1) {
				config.data.names.latePRCount = translate.instant('Unknown Age');
			}
			config.legend = {
				show: config.data.keys.value.length > 1,
				position: 'bottom',
				item: {
					onclick: function (id) {
						scope.chart.toggle(id);
						var selectedKeys = [];
						// update bgnum and delta
						var visibleValue = 0.0;
						var i;

						var lastPoint = config.data.json[config.data.json.length - 1];
						var visibleData = scope.chart.data.shown();
						for (i = 0; i < visibleData.length; i++) {
							 visibleValue += lastPoint[visibleData[i].id];
							 selectedKeys.push(visibleData[i].id);
						}
						$timeout(function () {
						 	scope.$parent.$parent.formattedBgNum.value = formatService.getWithParameters(
						 		visibleValue, 0, scope.currency);
						});

						scope.deltaValue = 0;

						if (config.data.json.length > 1) {
							var weeksBack = config.data.json.length >= 3 ? 3 : 2;
							var previousPoint = config.data.json[config.data.json.length - weeksBack];

							var previousValue = 0.0;
							for (i = 0; i < visibleData.length; i++) {
								previousValue += previousPoint[visibleData[i].id];
							}
							scope.deltaValue = visibleValue - previousValue;
							$timeout(function () {
								scope.$parent.formattedDiff.delta = formatService.getWithParameters(
									scope.deltaValue, 0, scope.currency);
							});
						}

						var url = decodeURIComponent(scope.$parent.content.drillDownUrl);
						var params = parseQueryString(url);
						var baseUrl = url.split('?')[0];
						// clear out existing date creation query params
						delete params.orderCreationDateValueOne;
						delete params.orderCreationDateValueTwo;
						delete params.orderCreationDateComparator;

						if (selectedKeys.length != 3) {
							selectedKeys = _.sortBy(selectedKeys).toString();

							var day13 = moment.utc().add(-13, 'd').format('YYYY-MM-DD');
							var day14 = moment.utc().add(-14, 'd').format('YYYY-MM-DD');
							var day7 = moment.utc().add(-7, 'd').format('YYYY-MM-DD');

							switch (selectedKeys) {
							case 'latePRCountOver14':
								params['orderCreationDateValueOne'] = day14;
								params['orderCreationDateComparator'] = 'lt';
								break;
							case 'latePRCountUnder14':
								params['orderCreationDateValueOne'] = day13;
								params['orderCreationDateValueTwo'] = day7;
								params['orderCreationDateComparator'] = 'btw';
								break;
							case 'latePRCountUnder7':
								params['orderCreationDateValueOne'] = day7;
								params['orderCreationDateComparator'] = 'gte';
								break;
							case 'latePRCountOver14,latePRCountUnder14':
								params['orderCreationDateValueOne'] = day7;
								params['orderCreationDateComparator'] = 'lt';
								break;
							case 'latePRCountOver14,latePRCountUnder7':
								params['orderCreationDateValueOne'] = day13;
								params['orderCreationDateValueTwo'] = day7;
								params['orderCreationDateComparator'] = 'notbtw';
								break;
							case 'latePRCountUnder14,latePRCountUnder7':
								params['orderCreationDateValueOne'] = day13;
								params['orderCreationDateComparator'] = 'gte';
								break;
							}
						}
						scope.$parent.content.drillDownUrl = addQueryParam(baseUrl, null, params, false);
					}
				}
			};
			return config;
		}
	},
	'purchaseReqCreatedInsideLeadTime': {
		name: 'Purchase Requisitions Created Inside Lead Time',
		description: 'The percentage of purchase requisitions created inside or outside lead time based on the PR created date, grouped by weeks. ',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/pr_created_inside_lead_time.png',
		categories: ['All', 'Shortages'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:purchaseReqCreatedInsideLeadTimeCtrl:getChart',
		xAxisField: 'date',
		yAxisFieldLabel: 'PR Count',
		yAxisFieldName: 'PR Count',
		yAxisFieldKey: 'prsCreatedInsideLeadTime',
		fmtService: 'percentageFormatService',
		expandedTitle: 'PRs inside of lead time, sorted by days until PO firm',
		drillDownUrl: frontendPfx + 'supply-chain/purchase-requisitions-history?drilldown=1&prHistoryDateComparator=gte&prHistoryDateValueOne=' + moment.utc().add(-90, 'd').format('YYYY-MM-DD'),
		bgNumUnits: 'PRs',
		bgNumKey: 'prsCreatedInsideLeadTime',
		widgetName: 'Purchase Requisitions Created Inside Lead Time',
		location: 'purchase req widget',
		graphConfig: function(config, scope, translate, formatService, $timeout, weeklyDiffService) {
			var threeMonthAgo = moment.utc().add(-90, 'd').format('YYYY-MM-DD');
			config.data.json = config.data.json.map(function(row) {
				// default values to zero - because 'fake' weeks don't have all the values
				row = _.extend(
					{
						prsCreatedInsideLeadTime: 0,
						prsCreatedOutsideLeadTime: 0,
						prsCreatedInsideLeadTimeManufactured: 0,
						prsCreatedOutsideLeadTimeManufactured: 0,
						prsCreatedInsideLeadTimePercent: 0,
						prsCreatedOutsideLeadTimePercent: 0,
						percentCreated: 0
					},
					row
				);
				// Aggregate manufactured
				row.prsCreatedInsideLeadTime += row.prsCreatedInsideLeadTimeManufactured;
				row.prsCreatedOutsideLeadTime += row.prsCreatedOutsideLeadTimeManufactured;
				// zero out the "Unknown Age" values when newer age based data is available
				if (row.totalPRCount === undefined) {
					row.totalPRCount = row.prsCreatedInsideLeadTime + row.prsCreatedOutsideLeadTime;
					if (row.totalPRCount !== 0) {
						row.prsCreatedInsideLeadTimePercent = row.prsCreatedInsideLeadTime / row.totalPRCount * 100;
						row.prsCreatedOutsideLeadTimePercent = row.prsCreatedOutsideLeadTime / row.totalPRCount * 100;
					}
				}
				return row;
			});
			var weeks = config.data.json;
			if (weeks.length >= 1) {
				if (scope.$parent.formattedBgNum) {
					scope.$parent.formattedBgNum.value = formatService.getWithParameters(weeks[weeks.length - 1].prsCreatedInsideLeadTimePercent, 0);
				}
			}
			if (weeks.length >= 2) {
				var diff = weeklyDiffService.getDataPoints(weeks);
				var delta = diff.lastDataPoint.prsCreatedInsideLeadTimePercent - diff.previousDataPoint.prsCreatedInsideLeadTimePercent;
				if (isNaN(delta)) {
					scope.$parent.diff = null;
				} else {
					scope.$parent.diff = {
						delta: delta,
						status: delta > 0 ? 'bad' : 'good'
					};
					scope.$parent.formattedDiff = {
						delta: formatService.getWithParameters(Math.abs(delta), 0),
						addnlLabelText: weeklyDiffService.getAdditionalLabelText(diff.previousDataPoint)
					};
				}
			}
			config.data.type = 'bar';
			config.data.x = 'date';
			config.axis.y.min = 0;
			config.axis.y.max = 100;
			config.axis.x.type = 'category';
			var format = config.axis.x.tick.format;
			config.axis.x.tick = {
				format: function(x) {
					return format(config.data.json[Math.round(x)]['date']);
				},
				outer: false,
				count: 5,
				multiline: false
			};
			config.data.names = {
				prsCreatedInsideLeadTimePercent: translate.instant('Inside Lead Times'),
				prsCreatedOutsideLeadTimePercent: translate.instant('Outside Lead Times')
			};
			config.data.order = function(t1, t2) {
				// sort in same order as the config.data.groups[0] array
				// first item in array at bottom of stack
				// this is the opposite of the order they appear in code, where
				// first item is on the top of a list.
				var a = config.data.groups[0].indexOf(t1.id),
					b = config.data.groups[0].indexOf(t2.id);
				return a > b ? 1 : a < b ? -1 : 0;
			};
			config.data.groups = [
				[
					'prsCreatedInsideLeadTimePercent',
					'prsCreatedOutsideLeadTimePercent'
				]
			];
			config.tooltip = {
				contents: function(d, defaultTitleFormat, defaultValueFormat, color) {
					var $$ = this,
						config = $$.config,
						CLASS = $$.CLASS,
						titleFormat = config.tooltip_format_title || defaultTitleFormat,
						nameFormat = config.tooltip_format_name || function (name) {
							return name;
						},
						valueFormat = config.tooltip_format_value || defaultValueFormat,
						text, i, title, value, name, bgcolor;

					for (i = 0; i < d.length; i++) {
						if (!(d[i] && (d[i].value || d[i].value === 0))) {
							continue;
						}
						if (!text) {
							title = titleFormat ? titleFormat(d[i].x) : d[i].x;
							text = '<table class="' + CLASS.tooltip + '">' +
								(title || title === 0 ?
									'<tr><th colspan="3">' + title + '</th></tr>' +
									'<tr><td></td><td>Percent</td><td>Count</td></tr>' :
									'');
						}
						value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
						if (value !== undefined) {
							text += '<tr class="' + CLASS.tooltipName + '-' + d[i].id + '">';
							text += '<td class="name"><span style="background-color:' + color(d[i]) + '"></span>' +
								d[i].name + '</td>';
							text += '<td class="value">' + value + '</td>';
							text += '<td class="value">' + d3.format(',')(this.config.data_json[d[i].index][_.replace(d[i].id, 'Percent', '')]) + '</td>';
							text += '</tr>';
						}
					}
					return text + '</table>';
				}
			};
			config.size.height = Math.max(250, config.size.height);
			config.data.color = undefined;
			config.data.colors = {
				prsCreatedInsideLeadTimePercent: '#D30A0A',
				prsCreatedOutsideLeadTimePercent: '#0C9D4D'
			};

			config.data.keys.value = config.data.groups[0].filter(function(group) {
				return Math.max.apply(null, _.map(config.data.json, group)) > 0;
			});
			if (config.data.keys.value.length > 1) {
				config.data.names.latePRCount = translate.instant('Unknown Age');
			}
			config.legend = {
				show: config.data.keys.value.length > 1,
				position: 'bottom'
			};
			return config;
		}
	},
	'ppoInsideLeadTime': {
		name: 'Planned Production Orders Inside Lead Time',
		description: 'Weekly summary of number of PPOs that need to be firmed, grouped by creation date (less than 7 days, 7 - 14 days, 14 days or more).',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/pr_inside_lead_time.png',
		categories: ['All', 'Shortages'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:ppoInsideLeadTimeCtrl:getChart',
		xAxisField: 'date',
		yAxisFieldLabel: 'PPO Count',
		yAxisFieldName: 'PPO Count',
		yAxisFieldKey: 'latePPOCountManufactured',
		fmtService: 'integerFormatService',
		expandedTitle: 'PPOs inside of lead time, sorted by days until PO firm',
		tableUrl: urlPfx + '/TopPPOInsideLeadTimeItems',
		reactDrilldownUrl: frontendPfx + 'supply-chain/planned-production-orders/',
		reactDrilldownFilters: [{id: 'daysUntilPOFirm', comparator: 'Less Than Or Equal To', valueOne: -1}, {id: 'itemType', values: ['Manufactured']}],
		reactDrilldownSorters: [{ property: 'daysUntilPOFirm', direction: 'ASC' }],
		bgNumUnits: 'PPOs',
		bgNumKey: 'latePPOCountManufactured',
		widgetName: 'PPO Inside Leadtime',
		location: 'ppo inside leadtime widget',
		graphConfig: function(config, scope, translate, formatService, $timeout, weeklyDiffService) {
			config.data.json = config.data.json.map(function(row) {
				// default values to zero - because 'fake' weeks don't have all the values
				row = _.extend({ latePPOCountManufactured: 0, latePPOCountUnder7Manufactured: 0, latePPOCountUnder14Manufactured: 0, latePPOCountOver14Manufactured: 0}, row);
				// zero out the "Unknown Age" values when newer age based data is available
				if (row.totalPPOCount === undefined) {
					row.totalPPOCount = row.latePPOCountManufactured;
					row.latePPOCountManufactured = Math.max(0, row.latePPOCountManufactured - (row.latePPOCountUnder7Manufactured + row.latePPOCountUnder14Manufactured + row.latePPOCountOver14Manufactured));
				}
				return row;
			});
			var weeks = config.data.json;
			if (weeks.length >= 2) {
				var diff = weeklyDiffService.getDataPoints(weeks);
				var delta = diff.lastDataPoint.totalPPOCount - diff.previousDataPoint.totalPPOCount;
				if (isNaN(delta)) {
					scope.$parent.diff = null;
					scope.$parent.formattedDiff = null;
				} else {
					scope.$parent.diff = {
						delta: delta,
						status: delta > 0 ? 'bad' : 'good'
					};
					scope.$parent.formattedDiff = {
						delta: d3.format(',')(Math.abs(delta)),
						addnlLabelText: weeklyDiffService.getAdditionalLabelText(diff.previousDataPoint)
					};
				}
			}
			config.data.type = 'bar';
			config.data.x = 'date';
			config.axis.y.min = 0;
			config.axis.y.max = Math.max.apply(null, config.data.json.map(function(row) { return row.totalPPOCount; }));
			config.axis.x.type = 'category';
			var format = config.axis.x.tick.format;
			config.axis.x.tick = {
				format: function(x) {
					return format(config.data.json[Math.round(x)]['date']);
				},
				outer: false,
				count: 5,
				multiline: false
			};
			config.data.names = {
				latePPOCountManufactured: translate.instant('Late PPOs'),
				latePPOCountUnder7Manufactured: translate.instant('Created < 7 days ago'),
				latePPOCountUnder14Manufactured: translate.instant('Created 7-14 days ago'),
				latePPOCountOver14Manufactured: translate.instant('Created > 14 days ago')
			};
			config.data.order = function(t1, t2) {
				// sort in same order as the config.data.groups[0] array
				// first item in array at bottom of stack
				// this is the opposite of the order they appear in code, where
				// first item is on the top of a list.
				var a = config.data.groups[0].indexOf(t1.id),
					b = config.data.groups[0].indexOf(t2.id);
				return a > b ? 1 : a < b ? -1 : 0;
			};
			config.data.groups = [
				[
					'latePPOCountOver14Manufactured',
					'latePPOCountUnder14Manufactured',
					'latePPOCountUnder7Manufactured',
					'latePPOCountManufactured'
				]
			];
			config.tooltip = {
				contents: function(data, defaultTitleFormat, defaultValueFormat, color) {
					// don't show groups with 0 PPOs in tooltip
					var popupData = data.filter(function(i) { return i.value !== 0; } );
					if (!popupData || popupData.length == 0) {
						return '';
					}
					if (popupData.length > 1) {
						var total = popupData.reduce(function(total,i){ return total+i.value; }, 0);
						popupData.push({ name: translate.instant('Total Late PPOs'), id: 'totalPPOCount', value: total, x: data[0].x });
					}
					return this.getTooltipContent(popupData, defaultTitleFormat, defaultValueFormat, color);
				}
			};
			config.size.height = Math.max(250, config.size.height);
			config.data.color = undefined;
			config.data.colors = {
				latePPOCountUnder7Manufactured: '#0C9D4D',
				latePPOCountUnder14Manufactured: '#F4CE00',
				latePPOCountOver14Manufactured: '#D30A0A',
				latePPOCountManufactured: '#005FA5',
				totalPPOCount: '#ffffff'
			};

			config.data.keys.value = config.data.groups[0].filter(function(group) {
				return Math.max.apply(null, _.map(config.data.json, group)) > 0;
			});
			if (config.data.keys.value.length > 1) {
				config.data.names.latePPOCountManufactured = translate.instant('Unknown Age');
			}
			config.legend = {
				show: config.data.keys.value.length > 1,
				position: 'bottom',
				item: {
					onclick: function (id) {
						scope.chart.toggle(id);
						var selectedKeys = [];
						// update bgnum and delta
						var visibleValue = 0.0;
						var i;

						var lastPoint = config.data.json[config.data.json.length - 1];
						var visibleData = scope.chart.data.shown();
						for (i = 0; i < visibleData.length; i++) {
							 visibleValue += lastPoint[visibleData[i].id];
							 selectedKeys.push(visibleData[i].id);
						}
						$timeout(function () {
						 	scope.$parent.$parent.formattedBgNum.value = formatService.getWithParameters(
						 		visibleValue, 0, scope.currency);
						});

						scope.deltaValue = 0;

						if (config.data.json.length > 1) {
							var weeksBack = config.data.json.length >= 3 ? 3 : 2;
							var previousPoint = config.data.json[config.data.json.length - weeksBack];

							var previousValue = 0.0;
							for (i = 0; i < visibleData.length; i++) {
								previousValue += previousPoint[visibleData[i].id];
							}
							scope.deltaValue = visibleValue - previousValue;
							$timeout(function () {
								scope.$parent.formattedDiff.delta = formatService.getWithParameters(
									scope.deltaValue, 0, scope.currency);
							});
						}

						var url = decodeURIComponent(scope.$parent.content.drillDownUrl);
						var params = parseQueryString(url);
						var baseUrl = url.split('?')[0];
						// clear out existing date creation query params
						delete params.orderCreationDateValueOne;
						delete params.orderCreationDateValueTwo;
						delete params.orderCreationDateComparator;

						if (selectedKeys.length != 3) {
							selectedKeys = _.sortBy(selectedKeys).toString();

							var day13 = moment.utc().add(-13, 'd').format('YYYY-MM-DD');
							var day14 = moment.utc().add(-14, 'd').format('YYYY-MM-DD');
							var day7 = moment.utc().add(-7, 'd').format('YYYY-MM-DD');

							switch (selectedKeys) {
							case 'latePPOCountOver14Manufactured':
								params['orderCreationDateValueOne'] = day14;
								params['orderCreationDateComparator'] = 'lt';
								break;
							case 'latePPOCountUnder14Manufactured':
								params['orderCreationDateValueOne'] = day13;
								params['orderCreationDateValueTwo'] = day7;
								params['orderCreationDateComparator'] = 'btw';
								break;
							case 'latePPOCountUnder7Manufactured':
								params['orderCreationDateValueOne'] = day7;
								params['orderCreationDateComparator'] = 'gte';
								break;
							case 'latePPOCountOver14Manufactured,latePPOCountUnder14Manufactured':
								params['orderCreationDateValueOne'] = day7;
								params['orderCreationDateComparator'] = 'lt';
								break;
							case 'latePPOCountOver14Manufactured,latePPOCountUnder7Manufactured':
								params['orderCreationDateValueOne'] = day13;
								params['orderCreationDateValueTwo'] = day7;
								params['orderCreationDateComparator'] = 'notbtw';
								break;
							case 'latePPOCountUnder14Manufactured,latePPOCountUnder7Manufactured':
								params['orderCreationDateValueOne'] = day13;
								params['orderCreationDateComparator'] = 'gte';
								break;
							}
						}
						scope.$parent.content.drillDownUrl = addQueryParam(baseUrl, null, params, false);
					}
				}
			};
			return config;
		}
	},
	'prOnTimeFirmDate': {
		name: 'Purchase Requisition On Time Firm Dates',
		description: 'The number of Purchase Requisitions inside supplier lead time, inside procurement lead time, and outside procurement lead time, grouped by week of PO on-time firm date (the date it needs to be converted to a firm PO before it will be late).',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/pr-weekly-pofirmdate.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:prOnTimeFirmDateCtrl:getChart',
		xAxisField: 'mondayDate',
		yAxisFieldKey: [
			'averagePOPlacement',
			'prLateCount',
			'prInsideCount',
			'prFutureCount'
		],
		bgHide: true,
		fmtService: 'integerFormatService',
		expandedTitle: 'Daily count of Purchase Requisitions grouped by week of PO On Time Firm Date.',
		chartUrl: urlPfx + '/PRCountsByFirmDate?documentType=PurchaseRequisitions',
		drillDownUrl: frontendPfx + 'supply-chain/purchase-requisitions/?drilldown=1&sort=daysUntilPOFirm',
		reactDrilldownUrl: frontendPfx + 'supply-chain/purchase-requisitions/',
		reactDrilldownSorters: [{ property: 'daysUntilPOFirm', direction: 'ASC' }],
		graphConfig: function(config, scope) {
			var data = config.data.json;
			config.size.height = Math.max(250, config.size.height);
			config.padding.top = 20;
			config.data.type = 'bar';
			config.data.types = {
				averagePOPlacement: 'line'
			};
			config.bar = {
				width: {
					ratio: 0.7
				}
			};
			var format = config.axis.x.tick.format;
			config.axis.x = {
				type: 'category',
				tick: {
					multiline: false,
					centered: true,
					outer: false,
					format: function(i) {
						if (data[i].relativeWeek === 0) {
							return 'this week';
						}
						var sunday = format(data[i].mondayDate.getTime()+SIX_DAYS);
						if (i === 0) {
							return '<= ' + sunday;
						}
						return sunday;
					},
					values: [0, 4, 11, 22, 37]
				}
			};
			var averagePOPlacement = '';
			if (scope.$parent.$parent.extraAxes) {
				averagePOPlacement = scope.$parent.$parent.extraAxes['averageWeeklyPlacement'];
				data.forEach(function(d){ d.averagePOPlacement = averagePOPlacement; });
				config.axis.y.max = Math.max(averagePOPlacement * 1.15, Math.max.apply(null, _.map(_.filter(data, 'prCount'), 'prCount')));
			}
			config.data.names = {
				averagePOPlacement: 'Avg. PO Placement (13 wks)',
				prLateCount: 'Past due',
				prInsideCount: 'Inside Procurement Lead Time',
				prFutureCount: 'Outside Procurement Lead Time'
			};
			config.data.color = undefined;
			config.data.colors = {
				prLateCount: '#D30A0A',
				prInsideCount: '#F4CE00',
				prFutureCount: '#005FA5',
				averagePOPlacement: '#0c9d4d'
			};
			config.data.groups = [
				[
					'prLateCount',
					'prInsideCount',
					'prFutureCount'
				]
			];
			config.tooltip = {
				format: {
					title: function(x) {
						var mon = format(data[x].mondayDate.getTime());
						var sun = format(data[x].mondayDate.getTime()+SIX_DAYS);
						if (x === 0) {
							return 'On or before ' + sun;
						}
						return mon + ' - ' + sun;
					}
				},
				contents: function(data, defaultTitleFormat, defaultValueFormat, color) {
					// don't show groups with 0 PRs in tooltip
					data = data.filter(function(i) { return i.value !== 0 || i.id === 'averagePOPlacement'; } );
					return this.getTooltipContent(data, defaultTitleFormat, defaultValueFormat, color);
				}
			};
			config.legend = {
				show: true,
				hide: ['averagePOPlacement'],
				position: 'bottom'
			};
			return config;
		}
	},
	'ppoOnTimeFirmDates': {
		name: 'Planned Production Orders On Time Firm Dates',
		description: 'Daily count of PPOs grouped by week of On Time Firm Date.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/pr-weekly-pofirmdate.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:ppoOnTimeFirmDatesCtrl:getChart',
		xAxisField: 'mondayDate',
		yAxisFieldKey: [
			'averagePOPlacement',
			'prLateCount',
			'prInsideCount',
			'prFutureCount'
		],
		bgHide: true,
		fmtService: 'integerFormatService',
		expandedTitle: 'Daily count of Planned Production Orders grouped by week of On Time Firm Date.',
		chartUrl: urlPfx + '/PRCountsByFirmDate?documentType=PlannedProductionOrders',
		reactDrilldownUrl: frontendPfx + 'supply-chain/planned-production-orders/',
		reactDrilldownFilters: [{id: 'itemType', values: ['Manufactured']}],
		reactDrilldownSorters: [{ property: 'daysUntilPOFirm', direction: 'ASC' }],
		graphConfig: function(config, scope) {
			var data = config.data.json;
			config.size.height = Math.max(250, config.size.height);
			config.axis.y.min = 0;
			config.padding.top = 20;
			config.data.type = 'bar';
			config.data.types = {
				averagePOPlacement: 'line'
			};
			config.bar = {
				width: {
					ratio: 0.7
				}
			};
			var format = config.axis.x.tick.format;
			config.axis.x = {
				type: 'category',
				tick: {
					multiline: false,
					centered: true,
					outer: false,
					format: function(i) {
						if (data[i].relativeWeek === 0) {
							return 'this week';
						}
						var sunday = format(data[i].mondayDate.getTime()+SIX_DAYS);
						if (i === 0) {
							return '<= ' + sunday;
						}
						return sunday;
					},
					values: [0, 4, 11, 22, 37]
				}
			};
			var averagePOPlacement = '';
			if (scope.$parent.$parent.extraAxes) {
				averagePOPlacement = scope.$parent.$parent.extraAxes['averageWeeklyPlacement'];
				data.forEach(function(d){ d.averagePOPlacement = averagePOPlacement; });
				config.axis.y.max = Math.max(averagePOPlacement * 1.15, Math.max.apply(null, _.map(_.filter(data, 'prCount'), 'prCount')));
			}
			config.data.names = {
				averagePOPlacement: 'Avg. Production Order Placement (13 wks)',
				prLateCount: 'Past due',
				prInsideCount: 'Inside Procurement Lead Time',
				prFutureCount: 'Outside Procurement Lead Time'
			};
			config.data.color = undefined;
			config.data.colors = {
				prLateCount: '#D30A0A',
				prInsideCount: '#F4CE00',
				prFutureCount: '#005FA5',
				averagePOPlacement: '#0c9d4d'
			};
			config.data.groups = [
				[
					'prLateCount',
					'prInsideCount',
					'prFutureCount'
				]
			];
			config.tooltip = {
				format: {
					title: function(x) {
						var mon = format(data[x].mondayDate.getTime());
						var sun = format(data[x].mondayDate.getTime()+SIX_DAYS);
						if (x === 0) {
							return 'On or before ' + sun;
						}
						return mon + ' - ' + sun;
					}
				},
				contents: function(data, defaultTitleFormat, defaultValueFormat, color) {
					// don't show groups with 0 PRs in tooltip
					data = data.filter(function(i) { return i.value !== 0 || i.id === 'averagePOPlacement'; } );
					return this.getTooltipContent(data, defaultTitleFormat, defaultValueFormat, color);
				}
			};
			config.legend = {
				show: true,
				hide: ['averagePOPlacement'],
				position: 'bottom'
			};
			return config;
		}
	},
	'poPlacement': {
		name: 'Purchase Order Placements',
		description: 'Count of Purchase Orders placed per week.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/po-placement.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:poPlacementCtrl:getChart',
		bottomData: false,
		xAxisField: 'mondayDate',
		xAxisInterval: 'weekly',
		yAxisFieldKey: 'poCount',
		fmtService: 'integerFormatService',
		expandedTitle: 'Count of POs placed per week that were planned (associated with PR) or unplanned (not associated with PR).',
		chartUrl: urlPfx + '/POPlacementsByWeek?documentType=PurchaseOrders',
		drillDownUrl: frontendPfx + 'supply-chain/purchase-orders/?drilldown=1&sort=orderDate&itemType=Purchased',
		reactDrilldownUrl: frontendPfx + 'supply-chain/purchase-orders/',
		reactDrilldownSorters: [{ property: 'orderDate', direction: 'ASC' }],
		reactDrilldownFilters: [{id: 'itemType', values: ['Purchased'] }],
		isPoReport: true,
		templateUrl: '/application/f/dashboard/widgets/poPlacementWidget.html',
		ignoreFilters: ['timePeriod'],
		placementUrl: function(breakDown) {
			if (breakDown === 'POPlacementsByMonth') {
				return urlPfx + '/POPlacementsByMonth?documentType=PurchaseOrders';
			}
			return urlPfx + '/POPlacementsByWeek?documentType=PurchaseOrders';
		},
		bgNumValIdx: function(data, breakDown) {
			if (!breakDown || breakDown === 'None') {
				var now = new Date();
				var currentWeek = now.getDay() <= 1 ? -1 : 0;
				for (var i = data.length-1; i >= 0; i--) {
					if (data[i].relativeWeek === currentWeek) {
						return i;
					}
				}
			}

			return data.length - 1;
		},
		graphConfig: function(config, $scope) {
			var data = config.data.json;
			config.size.height = Math.max(250, config.size.height);
			config.padding.right = 30;
			config.data.type = 'bar';
			config.bar = {
				width: {
					ratio: 0.7
				}
			};
			config.data.names = {
				poCount: 'POs Placed'
			};
			var format = config.axis.x.tick.format;
			config.axis.x = {
				type: 'category',
				tick: {
					multiline: false,
					centered: true,
					outer: false,
					fit: true,
					format: function(i) {
						return moment.utc(data[Math.round(i)].mondayDate.getTime()+SIX_DAYS).format('MMM DD YYYY');
					},
					count: 3
				}
			};
			config.axis.y.min = 0;
			config.data.color = undefined;
			config.data.colors = { poCount: '#a93491' };
			config.tooltip = {
				format: {
					title: function(x) {
						var mon = format(data[x].mondayDate);
						var sun = format(data[x].mondayDate.getTime()+SIX_DAYS);
						return mon + ' - ' + sun;
					}
				}
			};
			config.data.onclick = function(d, element) {
				var weekStart = moment.utc(data[d.index].mondayDate);
				var startDate = weekStart.format('YYYY-MM-DD');
				var endDate = weekStart.add(6, 'd').format('YYYY-MM-DD');
				var url = '';
				var isBlanketOrdersExperimentOn = $scope.$parent.$parent.allFeatures['supply-and-demand-blanket-checkbox'];
				var isNoImpactSupplyExperimentOn = $scope.$parent.$parent.allFeatures['no-impact-supply'];
				var reactGraphDrilldownFilters = [
					{ id: 'itemType', values: ['Purchased'] },
					{ id: 'orderCreationDate', comparator: 'Between', valueOne: startDate, valueTwo: endDate }
				];
				if (isBlanketOrdersExperimentOn) {
					reactGraphDrilldownFilters.push(
						{ id: 'isBlanketOrder', values: [false] }
					);
				}
				if (isNoImpactSupplyExperimentOn) {
					reactGraphDrilldownFilters.push(
						{ id: 'excludeNonQuantitySupply', values: ['Yes'] },
						{ id: 'excludeNonValueSupply', values: ['Yes'] }
					);
				}
				var reactGraphDrilldownSorters = [
					{ property: 'originalRequestedDate', direction: 'ASC' }
				];
				url = $scope.$parent.$parent.reactReportDrilldownUrl(reactGraphDrilldownFilters, reactGraphDrilldownSorters, true);
				window.open(url, '_blank');
			};

			return config;
		}
	},
	'productionOrderPlacement': {
		name: 'Production Order Placements',
		description: 'Count of Production Orders created per week.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/po-placement.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:productionOrderPlacementCtrl:getChart',
		bottomData: false,
		xAxisField: 'mondayDate',
		xAxisInterval: 'weekly',
		yAxisFieldKey: 'poCount',
		fmtService: 'integerFormatService',
		expandedTitle: 'Count of Production Orders created per week.',
		chartUrl: urlPfx + '/POPlacementsByWeek?documentType=ProductionOrders',
		reactDrilldownUrl: frontendPfx + 'supply-chain/production-orders/',
		reactDrilldownSorters: [{ property: 'orderCreationDate', direction: 'ASC' }],
		reactDrilldownFilters: [{ id: 'itemType', values: ['Manufactured'] }],
		bgNumValIdx: function(data) {
			var now = new Date();
			var currentWeek = now.getDay() <= 1 ? -1 : 0;
			for (var i = data.length-1; i >= 0; i--) {
				if (data[i].relativeWeek === currentWeek) {
					return i;
				}
			}
			return data.length - 1;
		},
		graphConfig: function(config, $scope) {
			var data = config.data.json;
			config.size.height = Math.max(250, config.size.height);
			config.padding.right = 30;
			config.data.type = 'bar';
			config.bar = {
				width: {
					ratio: 0.7
				}
			};
			config.data.names = {
				poCount: 'Production Orders Created'
			};
			var format = config.axis.x.tick.format;
			config.axis.x = {
				type: 'category',
				tick: {
					multiline: false,
					centered: true,
					outer: false,
					fit: true,
					format: function(i) {
						return moment.utc(data[Math.round(i)].mondayDate.getTime()+SIX_DAYS).format('MMM DD YYYY');
					},
					count: 3
				}
			};
			config.axis.y.min = 0;
			config.data.color = undefined;
			config.data.colors = { poCount: '#a93491' };
			config.tooltip = {
				format: {
					title: function(x) {
						var mon = format(data[x].mondayDate);
						var sun = format(data[x].mondayDate.getTime()+SIX_DAYS);
						return mon + ' - ' + sun;
					}
				}
			};
			config.data.onclick = function(d, element) {
				var weekStart = moment.utc(data[d.index].mondayDate);
				var startDate = weekStart.format('YYYY-MM-DD');
				var endDate = weekStart.add(6, 'd').format('YYYY-MM-DD');

				var reactGraphDrilldownFilters = [
					{ id: 'itemType', values: ['Manufactured'] },
					{ id: 'orderCreationDate', comparator: 'Between', valueOne: startDate, valueTwo: endDate }
				];
				var reactGraphDrilldownSorters = [
					{ property: 'goldenSupplyDate', direction: 'DESC' }
				];
				var url = $scope.$parent.$parent.reactReportDrilldownUrl(reactGraphDrilldownFilters, reactGraphDrilldownSorters, true);
				
				window.open(url, '_blank');
			};

			return config;
		}
	},
	'poConfirmation': {
		name: 'PO Confirmation Rate',
		description: 'Displays a monthly breakdown of confirmed vs unconfirmed POS.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/po-confirmation-rate.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:poConfirmationCtrl:getChart',
		xAxisField: 'date',
		fmtService: 'percentageFormatService',
		expandedTitle: '',
		chartUrl: urlPfx + '/POConfirmationByMonth?documentType=PurchaseOrders',
		drillDownUrl: frontendPfx + 'supply-chain/purchase-orders/?drilldown=1&&itemType=Purchased&sort=poStatus&sortDesc=1&mandatoryColumns=poStatus',
		reactDrilldownUrl: frontendPfx + 'supply-chain/purchase-orders/',
		reactDrilldownFilters: [{id: 'itemType', values: ['Purchased'] }],
		reactDrilldownSorters: [{ property: 'poStatus', direction: 'DESC' }],
		reactDrilldownMandatoryColumns: ['poStatus'],
		isPoReport: true,
		widgetName: 'PO Confirmation Rate',
		ignoreFilters: ['timePeriod'],
		updateKpiOnGroupLegendClick: false,
		graphConfig: function(config, scope, translate, formatService, $timeout) {
			var chartData = _.cloneDeep(config.data.json);
			config.data.json = config.data.json.map(function(row) {
				// default values to zero - because 'fake' weeks don't have all the values
				row = _.extend({ confirmedUnder7: 0, confirmed7To14: 0, confirmedOver14: 0, unconfirmed: 0, confirmedPercent: 0}, row);
				// zero out the "Unknown Age" values when newer age based data is available
				var confirmdPos = row.confirmedUnder7 + row.confirmed7To14 + row.confirmedOver14;
				var totalPos = confirmdPos + row.unconfirmed;
				if (totalPos) {
					row.confirmedUnder7Percent = row.confirmedUnder7/totalPos * 100;
					row.confirmed7To14Percent = row.confirmed7To14/totalPos * 100;
					row.confirmedOver14Percent = row.confirmedOver14/totalPos * 100;
					row.unconfirmedPercent = row.unconfirmed/totalPos * 100;
					row.confirmedPercent = confirmdPos/totalPos * 100;
				}
				return row;
			});

			var weeks = config.data.json;
			if (weeks.length >= 2) {
				var currentWeekVal = weeks[weeks.length - 1].confirmedPercent;
				var lookBack = weeks.length >= 3 ? 3 : 2;
				var prevWeekVal = weeks[weeks.length - lookBack].confirmedPercent;
				var delta =  currentWeekVal - prevWeekVal;
				if (scope.$parent.formattedBgNum) {
					scope.$parent.formattedBgNum.value = formatService.getWithParameters(currentWeekVal, 0);
				}
				if (isNaN(delta)) {
					scope.$parent.diff = null;
					scope.$parent.formattedDiff = null;
				} else {
					scope.$parent.diff = {
						delta: delta,
						status: delta > 0 ? 'good' : 'bad'
					};
					scope.$parent.formattedDiff = {
						delta: formatService.getWithParameters(Math.abs(delta), 0),
						addnlLabelText: translate.instant('since last month')
					};
				}
			}
			config.data.type = 'bar';
			config.axis.y.min = 0;
			config.axis.y.max = 100;
			config.axis.x.type = 'category';
			config.axis.x.height = 70;
			config.axis.x = {
				type: 'category',
				tick: {
					outer: false,
					count: 5,
					format: function(x) {
						return moment(config.data.json[Math.round(x)]['date']).format('MMM YYYY');
					},
					multiline: false
				}
			};
			config.data.names = {
				confirmedUnder7Percent: translate.instant('Confirmed < 7 Days'),
				confirmed7To14Percent: translate.instant('Confirmed 7-14 Days'),
				confirmedOver14Percent: translate.instant('Confirmed > 14 Days '),
				unconfirmedPercent: translate.instant('Unconfirmed')
			};
			config.data.order = function(t1, t2) {
				// sort in same order as the config.data.groups[0] array
				// first item in array at bottom of stack
				// this is the opposite of the order they appear in code, where
				// first item is on the top of a list.
				var a = config.data.groups[0].indexOf(t1.id),
					b = config.data.groups[0].indexOf(t2.id);
				return a > b ? 1 : a < b ? -1 : 0;
			};
			config.data.groups = [
				[
					'confirmedUnder7Percent',
					'confirmed7To14Percent',
					'confirmedOver14Percent',
					'unconfirmedPercent'
				]
			];
			config.tooltip = {
				contents: function(d, defaultTitleFormat, defaultValueFormat, color) {
					var $$ = this,
						config = $$.config,
						CLASS = $$.CLASS,
						titleFormat = config.tooltip_format_title || defaultTitleFormat,
						nameFormat = config.tooltip_format_name || function (name) {
							return name;
						},
						valueFormat = config.tooltip_format_value || defaultValueFormat,
						text, i, title, value, name, bgcolor;

					for (i = 0; i < d.length; i++) {
						if (!(d[i] && (d[i].value || d[i].value === 0))) {
							continue;
						}
						if (!text) {
							title = titleFormat ? titleFormat(d[i].x) : d[i].x;
							text = '<table class="' + CLASS.tooltip + '">' +
								(title || title === 0 ?
									'<tr><th colspan="3">' + title + '</th></tr>' +
									'<tr><td></td><td>Percent</td><td>Count</td></tr>' :
									'');
						}
						value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
						if (value !== undefined) {
							text += '<tr class="' + CLASS.tooltipName + '-' + d[i].id + '">';
							text += '<td class="name"><span style="background-color:' + color(d[i]) + '"></span>' +
								d[i].name + '</td>';
							text += '<td class="value">' + value + '</td>';
							text += '<td class="value">' + d3.format(',')(this.config.data_json[d[i].index][_.replace(d[i].id, 'Percent', '')]) + '</td>';
							text += '</tr>';
						}
					}
					return text + '</table>';
				}
			};
			config.size.height = Math.max(250, config.size.height);
			config.data.color = undefined;
			config.data.colors = {
				confirmedUnder7Percent: '#005DA7',
				confirmed7To14Percent: '#0082E5',
				confirmedOver14Percent: '#79C3FC',
				unconfirmedPercent: '#D7D7D7'
			};

			config.data.keys.value = config.data.groups[0];
			config.legend = {
				show: config.data.keys.value.length > 1,
				position: 'bottom',
				item: {
					onclick: function (id) {
						scope.chart.toggle(id);
						var selectedKeys = [];
						// update bgnum and delta
						var i;

						var visibleData = scope.chart.data.shown();
						for (i = 0; i < visibleData.length; i++) {
							 selectedKeys.push(visibleData[i].id);
						}
						scope.$parent.bgHide = selectedKeys.length != this.config.data_groups[0].length;
					}
				}
			};
			return config;
		}
	},
	'purchasedInventory': {
		name: 'Purchased Inventory',
		description: 'Shows the current total on-hand value of purchased inventory.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:purchasedInventoryCtrl:getChart',
		yAxisFieldLabel: 'Inventory Level',
		yAxisFieldName: 'Total Value',
		fmtService: 'currencyFormatService',
		expandedTitle: 'Purchased inventory with largest weekly increase',
		tableUrl: urlPfx + '/LargestWkToWkIncrease',
		drillDownUrl: frontendPfx + 'supply-chain/inventory-opportunities/weekly-inventory-change/?drilldown=1&sort=weeklyInventoryDelta&sortDesc=1',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/weekly-inventory-change/',
		reactDrilldownSorters: [{ property: 'weeklyInventoryDelta', direction: 'DESC' }],
		widgetName: 'Purchased Inventory',
		location: 'purchased inventory widget'
	},
	'manufacturedInventory': {
		name: 'Manufactured Inventory',
		description: 'Shows the current total on-hand value of manufactured inventory.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:manufacturedInventoryCtrl:getChart',
		yAxisFieldLabel: 'Inventory Level',
		yAxisFieldName: 'Total Value',
		fmtService: 'currencyFormatService',
		expandedTitle: 'Manufactured inventory with largest weekly increase',
		tableUrl: urlPfx + '/ManufacturedWkToWkIncrease',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory/manufactured-inventory/',
		reactDrilldownSorters: [{ property: 'totalIncrease', direction: 'DESC' }],
		widgetName: 'Manufactured Inventory',
		location: 'manufactured inventory widget'
	},
	'vmiPartsUnderMin': {
		name: 'MinMax Items Under Min',
		description: 'Shows the number of items where the on-hand quantity is below the MinMax min level',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Shortages', 'Supplier Performance'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:vmiPartsUnderMinCtrl:getChart',
		yAxisFieldLabel: 'Parts Count',
		yAxisFieldName: 'Parts Under Min',
		fmtService: 'integerFormatService',
		addnlBgNumUnits: 'Items',
		drilldownDefaultTabs: 'historicalSection',
		expandedTitle: 'MinMax shortages, sorted by lead time',
		tableUrl: urlPfx + '/VmiPartsUnderMinDetail',
		reactDrilldownUrl: frontendPfx + 'supply-chain/material-shortages/minmax-items-under-min/',
		widgetName: 'MinMax Parts Under Min',
		location: 'MinMax under min widget'
	},
	'vmiInventoryOverMax': {
		name: 'MinMax Items Over Max',
		description: 'Shows the total MinMax items value that is over max.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Supplier Performance'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:vmiInventoryOverMaxCtrl:getChart',
		yAxisFieldValue: 'On Hand > Max Inventory',
		yAxisFieldName: 'Total Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'historicalSection',
		expandedTitle: 'MinMax items with the largest increase',
		tableUrl: urlPfx + '/VmiInventoryOverMaxByItem',
		drillDownUrl: frontendPfx + 'supply-chain/inventory-level-over-minmax-max/?drilldown=1&sort=weeklyInventoryDelta&sortDesc=1',
		widgetName: 'MinMax Inventory Over Max',
		location: 'MinMax inventory over max widget'
	},
	'itemsUnderSafetyStock': {
		name: 'Items Under Safety Stock (Purchased)',
		description: 'Shows the purchased items that are currently under safety stock.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Shortages'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:itemsUnderSafetyStockCtrl:getChart',
		yAxisFieldLabel: 'Parts Count',
		yAxisFieldName: 'Parts Under Safety Stock',
		fmtService: 'integerFormatService',
		addnlBgNumUnits: 'Items',
		drilldownDefaultTabs: 'historicalSection',
		expandedTitle: 'Purchased items under safety stock, sorted by lead time',
		tableUrl: urlPfx + '/ItemsUnderSafetyStockDetail?itemType=Purchased',
		reactDrilldownUrl: frontendPfx + 'supply-chain/material-shortages/items-under-safety-stock',
		reactDrilldownFilters: [{id: 'itemType', values: ['Purchased'] }],
		widgetName: 'Items Under Safety Stock',
		location: 'Items under safety stock widget'
	},
	'itemsUnderSafetyStockManufactured': {
		name: 'Items Under Safety Stock (Manufactured)',
		description: 'Shows the manufactured items that are currently under safety stock.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Shortages'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:itemsUnderSafetyStockManufacturedCtrl:getChart',
		yAxisFieldLabel: 'Parts Count',
		yAxisFieldName: 'Parts Under Safety Stock',
		fmtService: 'integerFormatService',
		addnlBgNumUnits: 'Items',
		drilldownDefaultTabs: 'historicalSection',
		expandedTitle: 'Manufactured items under safety stock, sorted by lead time',
		tableUrl: urlPfx + '/ItemsUnderSafetyStockDetail?itemType=Manufactured',
		reactDrilldownUrl: frontendPfx + 'supply-chain/material-shortages/items-under-safety-stock',
		reactDrilldownFilters: [{id: 'itemType', values: ['Manufactured'] }],
		widgetName: 'Items Under Safety Stock (Manufactured)',
		location: 'Items under safety stock manufactured widget'
	},
	'ropItemsOverMax': {
		name: 'Reorder Point Items Over Max',
		description: 'Shows the reorder point items that are currently over max level',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:ropItemsOverMaxCtrl:getChart',
		yAxisFieldValue: 'On Hand > Max Inventory',
		yAxisFieldName: 'Total Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'historicalSection',
		expandedTitle: 'Reorder point items with the largest increase',
		tableUrl: urlPfx + '/ROPOverMaxByItem',
		drillDownUrl: frontendPfx + 'supply-chain/reorder-point-items-over-max/?drilldown=1&sort=weeklyInventoryDelta&sortDesc=1',
		widgetName: 'Reorder Point Items Over Max',
		location: 'Reorder point items over max widget'
	},
	'posToCancelNext90Days': {
		name: 'POs to Action: Next 90 Days',
		description: 'The total potential savings based on adjusting POs in the next 90 days.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:posToCancelNext90DaysCtrl:getChart',
		yAxisFieldLabel: 'POs To Action Next 90 Days',
		yAxisFieldName: 'POs To Action',
		fmtService: 'currencyFormatService',
		expandedTitle: 'Inventory with highest value excess purchase orders next 90 days',
		tableUrl: urlPfx + '/PosToCancelNext90DaysByItem',
		drillDownUrl: frontendPfx + 'supply-chain/inventory-opportunities/next-90-days/?drilldown=1&sort=poToCancelNext90Days&sortDesc=1',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/next-90-days',
		reactDrilldownSorters: [{ property: 'poToCancelNext90Days', direction: 'DESC' }],
		widgetName: 'POs to Cancel Next 90 Days',
		location: 'pos to action next 90 days widget'
	},
	'openPOsForObsoleteMaterial': {
		name: 'POs for Obsolete Inventory',
		description: 'The total on order value for obsolete inventory.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:openPOsForObsoleteMaterialCtrl:getChart',
		yAxisFieldLabel: 'Open POs For Obsolete Material',
		yAxisFieldName: 'PO Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'stockSection',
		expandedTitle: 'Open POs for obsolete material, sorted by amount',
		tableUrl: urlPfx + '/ObsoletePoValueByItem',
		drillDownUrl: frontendPfx + 'supply-chain/inventory-opportunities/purchase-orders-to-cancel/?drilldown=1&sort=excessOnOrderValue&sortDesc=1&onOrderQuantity=0&excessType=obsolete',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/purchase-orders-to-cancel',
		reactDrilldownSorters: [{ property: 'excessOnOrderValue', direction: 'DESC' }],
		reactDrilldownFilters: [{id: 'onOrderQuantity', values: [0]}, {id: 'excessType', values: ['obsolete']}],
		title: 'POs for Obsolete Inventory',
		excludeMinMaxForDrilldown: true,
		widgetName: 'POs for Obsolete Inventory',
		location: 'pos for obsolete'
	},
	'openPOsForExcessOverLeadTimeMultiple': {
		name: 'POs for Excess Over Lead Time Multiple',
		description: 'The total on order value for excess inventory based on the items\' lead time multiple (which compares the lead time to the days coverage).',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:openPOsForExcessOverLeadTimeMultipleCtrl:getChart',
		yAxisFieldLabel: 'POs For Excess Over Lead Time Multiple',
		yAxisFieldName: 'PO Value',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'stockSection',
		expandedTitle: 'Open POs for excess material over lead time multiple, sorted by amount',
		tableUrl: urlPfx + '/PoExcessOverLeadTimeByItem',
		drillDownUrl: frontendPfx + 'supply-chain/pos-for-excess-over-lead-time-multiple/?drilldown=1&sort=analysisExcessOnOrderOverLTValue&sortDesc=1',
		title: 'POs For Excess Over Lead Time Multiple',
		excludeMinMaxForDrilldown: true,
		widgetName: 'POs for Excess Over Leadtime Multiple',
		location: 'pos for excess over leadtime widget'
	},
	'customTextWidget': {
		name: 'Custom Text',
		description: 'Write notes in a dashboard or make announcements on a shared dashboard',
		categories: ['All'],
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/custom_text.png',
		config: {},
		isActive: true,
		widgetName: 'Custom Text',
		location: 'custom text',
		isEditable: true
	},
	'daysOfInventory': {
		name: 'Days or Turns of Inventory',
		description: 'The number of days or turns of inventory on hand for both purchased items and finished goods. To get the number of inventory turns, divide 365 by days of inventory.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:daysOfInventoryCtrl:getChart',
		reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/pfep-all-items',
		reactDrilldownSorters: [{ property: 'estimatedSavings', direction: 'DESC' }],
		reactDrilldownFilters: [],
		yAxisFieldName: function (setting) {
			return (setting.doiCalculationTurnsOrDays || 'Days') + ' of Inventory';
		},
		yAxisFieldKey: function (settings) {
			var fieldName = settings.doiCalculationTurnsOrDays === 'Turns' ? 'turnsOfInventory' : 'daysOfInventory';
			fieldName += settings.doiCalculation; // 'Backwards' or 'Forwards'
			if (settings.doiCalculationItemType === 'Purchased Items') {
				fieldName += 'Purchased';
			} else {
				fieldName += 'FinishedGood';
			}
			return fieldName;
		},
		// yAxisFieldKey: 'daysOfInventory',
		fmtService: 'numberFormatService',
		addnlBgNumUnits: function (setting) { // additional units added to the end of the bgNum
			return setting.doiCalculationTurnsOrDays || 'Days';
		},
		expandedTitle: 'Purchased inventory with largest value over target',
		expandedTitleAlt: 'Finished Good inventory with largest value over target',
		tableUrl: urlPfx + '/DaysOfInventoryTopItems',
		drillDownUrls: {
			'Finished Goods': {
				drillDownUrl: frontendPfx + 'supply-chain/pfep-all-finished-goods/?drilldown=1&sort=estimatedSavings&sortDesc=1'
			},
			'Purchased Items': {
				drillDownUrl: frontendPfx + 'supply-chain/inventory-opportunities/pfep-all-items/?drilldown=1&sort=estimatedSavings&sortDesc=1',
				reactDrilldownUrl: frontendPfx + 'supply-chain/inventory-opportunities/pfep-all-items',
				reactDrilldownSorters: [{ property: 'estimatedSavings', direction: 'DESC' }],
				reactDrilldownFilters: []
			}
		},
		widgetName: 'Days or Turns of Inventory',
		location: 'days of inventory widget',
		isEditable: true,
		templateUrl: '/application/f/dashboard/widgets/daysOfInventoryWidget.html',
		getTableUrlParams: function (scope, chartProps) {
			return {
				itemType: {
					'Finished Goods': 'FinishedGood',
					'Purchased Items': 'Purchased'
				}[scope.settings.doiCalculationItemType]
			};
		},
		dataFunction: function (sourceData, settings) {
			function calculateDoi(demand, onHand) {
				if (demand === undefined || demand === 0) {
					return undefined;
				} else if (demand > 0) {
					return Math.min(9999, 365 * onHand / demand);
				} else {
					return 9999;
				}
			}
			function calculateTurns(days) {
				if (days === undefined) {
					return undefined;
				} else {
					return 365.0 / days;
				}
			}
			var currentDoiFieldKey = chartProperties['daysOfInventory'].yAxisFieldKey(_.defaults({ doiCalculationTurnsOrDays: 'Days' }, settings));
			angular.forEach(sourceData, function (dp) {
				dp.daysOfInventoryForwardsFinishedGood = calculateDoi(dp.futureDemandValueFinishedGood, dp.totalOnHandValueFinishedGood);
				dp.turnsOfInventoryForwardsFinishedGood = calculateTurns(dp.daysOfInventoryForwardsFinishedGood);
				var pastDemand = dp.pastDemandValueFinishedGood;
				if (pastDemand === undefined) {
					pastDemand = dp.pastDemandValue;
				}
				dp.daysOfInventoryBackwardsFinishedGood = calculateDoi(pastDemand, dp.totalOnHandValueFinishedGood);
				dp.turnsOfInventoryBackwardsFinishedGood = calculateTurns(dp.daysOfInventoryBackwardsFinishedGood);
				dp.daysOfInventoryForwardsPurchased = calculateDoi(dp.futureDemandValue, dp.totalOnHandValue);
				dp.turnsOfInventoryForwardsPurchased = calculateTurns(dp.daysOfInventoryForwardsPurchased);
				dp.daysOfInventoryBackwardsPurchased = calculateDoi(dp.pastDemandValue, dp.avgInventoryLast12Months);
				dp.turnsOfInventoryBackwardsPurchased = calculateTurns(dp.daysOfInventoryBackwardsPurchased);
				dp.daysOfInventory = dp[currentDoiFieldKey];
			});
		}
	},
	'poBehindSchedule': {
		name: 'Open POs Behind Schedule',
		description: 'Displays the total number of PO lines where the Purchase Order is past due.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Shortages', 'Supplier Performance'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:poBehindScheduleCtrl:getChart',
		yAxisFieldLabel: '# of PO Behind Schedule',
		yAxisFieldName: '# of PO Behind Schedule',
		yAxisFieldKey: 'latePOCount',
		fmtService: 'numberFormatService',
		expandedTitle: 'Open purchase orders with the earliest due dates',
		tableUrl: urlPfx + '/POBehindSchedule',
		drillDownUrl: frontendPfx + 'supply-chain/purchase-orders/?drilldown=1&deliveryStatus=NotDeliveredYetPastDue' +
			'&sort=goldenSupplyDate&sortDesc=0',
		reactDrilldownUrl: frontendPfx + 'supply-chain/purchase-orders/',
		reactDrilldownSorters: [{ property: 'goldenSupplyDate', direction: 'ASC' }],
		reactDrilldownFilters: [{id: 'deliveryStatus', values: ['Open - Behind Schedule']}],
		excludeMinMaxForDrilldown: true,
		isPoReport: true,
		widgetName: 'POs Behind Schedule',
		location: 'pos behind schedule widget',
		dataFunction: function (sourceData) {
			sourceData.forEach(function (sd) {
				sd.latePOCount = sd.latePOCount + sd.latePOCountManufactured;
			});
		}
	},
	'posToActionNext12MonthsHistory': {
		name: 'POs to Action: Next 12 Months',
		description: 'The total potential savings based on adjusting POs in the next 12 months.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:posToActionNext12MonthsHistoryCtrl:getChart',
		yAxisFieldLabel: 'POs to Action',
		yAxisFieldName: 'POs to Action',
		fmtService: 'currencyFormatService',
		expandedTitle: 'Inventory with highest value excess purchase orders next 12 months',
		chartUrl: urlPfx + '/PoToActionNext12MonthsHistory',
		tableUrl: urlPfx + '/PoToActionNext12MonthsTop5',
		drillDownUrl: '',
		isNewDrillDown: false,
		isDrillDown: false,
		widgetName: 'POs to Action Next 12 Months',
		location: 'pos to action next 12 months widget'
	},
	'mrpResizeOpportunity': {
		name: 'MRP Resize Opportunity',
		description: 'The total potential savings for items based on resizing MRP order policies including lot sizes, fixed order quantities, and order intervals.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Inventory'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:mrpResizeOpportunityCtrl:getChart',
		yAxisFieldLabel: 'MRP Resize Opportunity',
		yAxisFieldName: 'MRP Resize Opportunity',
		fmtService: 'currencyFormatService',
		drilldownDefaultTabs: 'stockSection',
		expandedTitle: 'Inventory with the largest amount of MRP resize opportunity, sorted by amount',
		tableUrl: urlPfx + '/TopMRPResizeOpportunity',
		drillDownUrl: '',
		isDrillDown: false,
		widgetName: 'MRP Resize Opportunity',
		location: 'mrp resize widget'
	},
	'shortagesByOrderLines': {
		name: 'Current Shortages by Order Lines',
		description: 'The total number of lines in the Shortages by Order Report.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Shortages'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:shortagesByOrderLinesCtrl:getChart',
		yAxisFieldLabel: 'Current Shortages by Order Lines',
		yAxisFieldName: 'Current Shortages by Order Lines',
		yAxisFieldKey: 'shortagesByOrderLinesCombined',
		fmtService: 'numberFormatService',
		drilldownDefaultTabs: 'stockSection',
		reactDrilldownUrl: frontendPfx + 'supply-chain/material-shortages/shortages-by-order/',
		reactDrilldownFilters: [
			{ id: 'requirementDate', comparator: 'Less Than', valueOne: moment.utc().add(1, 'd').valueOf() },
			{ id: 'itemType', values: ['LDNA_A_S'] }
		],
		expandedTitle: 'Shortages by Order lines ordered by requirement date',
		isDrillDown: true,
		isNewDrillDown: true,
		widgetName: 'Current Shortages by Order Lines',
		location: 'current shortages by order lines widget',
		dataFunction: function (sourceData) {
			sourceData.forEach(function (sd) {
				sd.shortagesByOrderLinesCombined = sd.shortagesByOrderLines + sd.shortagesByOrderLinesManufactured;
			});
		}
	},
	'componentAvailabilityPercent': {
		name: 'Component Availability %',
		description: "The percentage of your items that are available to cover past due or today's demand.",
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
		categories: ['All', 'Shortages'],
		slideshowView: true,
		isActive: true,
		eventName: 'event:componentAvailabilityPercentCtrl:getChart',
		yAxisFieldName: 'Component Availability %',
		yAxisFieldKey: 'componentAvailabilityPercent',
		yAxisMinAndMax: {yMin: 0, yMax: 100},
		fmtService: 'percentageFormatService',
		expandedTitle: 'Component Availability percent',
		reactDrilldownUrl: frontendPfx + 'supply-chain/material-shortages/shortages-by-item/',
		reactDrilldownFilters: function(settings) {
			return [
				{ id: 'itemType', values: settings.itemType.split(',') }
			];
		},
		isNewDrillDown: true,
		widgetName: 'Component Availability %',
		location: 'component availability percent widget',
		isEditable: true,
		templateUrl: '/application/f/dashboard/widgets/componentAvailabilityWidget.html',
		isBadFlipped: true,
		dataFunction: function(sourceData, settings) {
			var metricFieldPeriod = settings.breakdown === 'Current' ? 'Today' : 'Next7Days';
			sourceData.forEach(function(sd) {
				var numerator, denominator;
				switch(settings.itemType) {
				case 'Purchased':
					numerator = sd.componentAvailabilityItemCount;
					denominator = sd['hasPastDueDemandIncluding' + metricFieldPeriod + 'ItemCount'];
					break;
				case 'Manufactured':
					numerator = sd.componentAvailabilityItemCountManufactured;
					denominator = sd['hasPastDueDemandIncluding' + metricFieldPeriod + 'ItemCountManufactured'];
					break;
				default:
					numerator = sd.componentAvailabilityItemCount + sd.componentAvailabilityItemCountManufactured;
					denominator = sd['hasPastDueDemandIncluding' + metricFieldPeriod + 'ItemCount'] + sd['hasPastDueDemandIncluding' + metricFieldPeriod + 'ItemCountManufactured'];
				}
				if(denominator <= 0){
					sd.componentAvailabilityPercent = 0;
				} else {
					sd.componentAvailabilityPercent = 100 * numerator/denominator;
				}
			});
		}
	}
};

// create and register all the widgets
(function() {
	'use strict';

	angular.module('widgets.buyer')
	.config(buyerChartWidgetsConfig);

	buyerChartWidgetsConfig.$inject = ['dashboardProvider', 'WEEKLY_LOG_ITEM_FIELDS'];
	function buyerChartWidgetsConfig(dashboardProvider, WEEKLY_LOG_ITEM_FIELDS) {
		// register widget
		for (var i = 0; i < masterWidgetList.length; i++) {
			var chartName = masterWidgetList[i];
			var widgetConfig = getWidgetsDefaults(chartName, chartProperties[chartName], 'buyerChartController', WEEKLY_LOG_ITEM_FIELDS);
			dashboardProvider
				.widget(chartName, angular.extend({
					controller: 'buyerChartController'
				}, widgetConfig));
		}
	}
})();

function getWidgetsDefaults(chartName, properties, defaultController, WEEKLY_LOG_ITEM_FIELDS) {
	var chart = properties;
	// default values
	if (chart.templateUrl === undefined) {
		chart.templateUrl = '/application/f/dashboard/widgets/buyerWidget.html';
	}
	if (chart.isDrillDown === undefined) {
		chart.isDrillDown = true;
	}
	if (chart.isNewDrillDown === undefined) {
		chart.isNewDrillDown = true;
	}
	if (chart.reload === undefined) {
		chart.reload = true;
	}
	if (chart.controller === undefined) {
		chart.controller = defaultController;
	}
	if (chart.xAxisField === undefined) {
		chart.xAxisField = 'date';
	}
	if (chart.xAxisInterval === undefined) {
		chart.xAxisInterval = 'weekly';
	}
	if (chart.yAxisFieldKey === undefined) {
		chart.yAxisFieldKey = 'value';
		// default to wli definitions
		if (Array.isArray(WEEKLY_LOG_ITEM_FIELDS[chartName])) {
			chart.yAxisFieldKey = WEEKLY_LOG_ITEM_FIELDS[chartName].filter(function(field) {
				return field.field !== 'criticalityLvl';
			})
			.map(function(field) {
				return field.field + (field.type === 'Manufactured' ? 'Manufactured': '');
			});
		} else if (WEEKLY_LOG_ITEM_FIELDS[chartName]) {
			chart.yAxisFieldKey = WEEKLY_LOG_ITEM_FIELDS[chartName].field + (WEEKLY_LOG_ITEM_FIELDS[chartName].type === 'Manufactured' ? 'Manufactured' : '');
		}
	}
	if (chart.addnlLabelText === undefined) {
		chart.addnlLabelText = 'in the last 7 days';
	}
	if (chart.bottomData === undefined) {
		chart.bottomData = true;
	}
	if (chart.bgNumClass === undefined) {
		chart.bgNumClass = 'bgNumClass';
	}
	if (chart.bgNumParentDivClass === undefined) {
		chart.bgNumParentDivClass = 'twoValues';
	}
	if (chart.bgNumValIdx === undefined) {
		chart.bgNumValIdx = 'end';
	}
	if (chart.addnlBgNumUnits === undefined) {
		chart.addnlBgNumUnits = '';
	}
	if (chart.drilldownDefaultTabs === undefined) {
		chart.drilldownDefaultTabs = '';
	}
	if (chart.useFactoryFilter === undefined) {
		chart.useFactoryFilter = true;
	}
	if (chart.isEditable === undefined) {
		chart.isEditable = true;
	}

	if (WEEKLY_LOG_ITEM_FIELDS[chartName]) {
		chart.useWeeklyLogItem = true;
	}


	var widget = {
		name: chart.name,
		description: chart.description,
		thumbnailUrl: chart.thumbnailUrl,
		categories: chart.categories,
		config: chart.config,
		slideshowView: chart.slideshowView,
		isActive: chart.isActive,
		templateUrl: chart.templateUrl,
		drillDownUrl: chart.drillDownUrl,
		reactDrilldownUrl: chart.reactDrilldownUrl,
		reactDrilldownSorters: chart.reactDrilldownSorters,
		reactDrilldownFilters: chart.reactDrilldownFilters,
		reactDrilldownMandatoryColumns: chart.reactDrilldownMandatoryColumns,
		reactDrilldownExperiment: chart.reactDrilldownExperiment,
		isPoReport: chart.isPoReport,
		experiment: chart.experiment,
		isDrillDown: chart.isDrillDown,
		isNewDrillDown: chart.isNewDrillDown,
		ignoreFilters: chart.ignoreFilters,
		reload: chart.reload,
		title: chart.title,
		useFactoryFilter: chart.useFactoryFilter,
		isEditable: chart.isEditable,
		resolve: {
			title: function (config) {
				return (config && config.title) ? config.title : '';
			},
			type: function (config) {
				return (config && config.type) ? config.type : '';
			}
		}
	};

	return widget;
}
